import React from 'react';
import TableCard from '../../ContentCard/TableCard';
import ChartCard from '../../ContentCard/ChartCard';
import ContentCard from '../../ContentCard/ContentCard';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  categoryWithLabelsWrapper,
  categoryWrapper,
  noWrap,
} from '../../../DataTransformFactory';
import Formatter from '../../../FormatFactory';

export default function Performances(props) {
  const { t } = useTranslation('translation');
  const history = useHistory();

  const best_selling = {
    title: t('views.performances.best_selling'),
    columns: [
      { key: 'product_id', label: t('views.performances.cols.product_id') },
      { key: 'latest_sku', label: t('views.performances.cols.sku') },
      { key: 'latest_title', label: t('views.performances.cols.description') },
      {
        key: 'total_quantity',
        label: t('views.performances.cols.sold_qty'),
        formatter: Formatter.number,
      },
      {
        key: 'latest_stock',
        label: t('views.performances.cols.latest_stock'),
        formatter: Formatter.number,
      },
    ],
    id_key: 'product_id',
    api: {
      module: 'analytics',
      path: 'best_selling_products/table/v1/detailed',
      data_wrapper_opts: {
        data_key: 'data',
      },
      data_wrapper: noWrap,
      queryparams: {
        max_entry_count: 50,
      },
    },
    link: {
      route: '/performances/product/',
    },
    component: TableCard,
  };

  return [
    <div className="column is-full" key="best_selling">
      <ContentCard {...props} {...best_selling} />
    </div>,
  ];
}
